import ProvidentFundNewsView from '../../components/ProvidentFundNewsView';
export default function RegionPolicyBrowser(){return <ProvidentFundNewsView mode="region"/>;}
